import React from 'react';

interface TickerItemProps {
  text: string;
}

export default function TickerItem({ text }: TickerItemProps) {
  return (
    <span className="inline-flex items-center px-3 whitespace-nowrap">
      <span className="w-2 h-2 bg-brand-primary rounded-full mr-2" />
      {text}
    </span>
  );
}